import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSignInStyle0 = cosmosIconCss;

const CosmosIconSignIn$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSignIn extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '239f07873eea41cb25944a78b5e626c47d8b8696', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '38ae6020777ca22e67d736e194b3ed57f9da5d49', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '00e7ad54216e717ae9740640ae8557ad87b9600b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.5 16.5v3a.5.5 0 0 1-.5.5H2.5a.5.5 0 0 1-.5-.5v-17a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-2H3.5v15H12v-2a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5ZM9.919 7.284c.165.068.273.23.273.408v2.558H19.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-9.308v2.558a.442.442 0 0 1-.755.312L6.13 11.312a.442.442 0 0 1 0-.625L9.437 7.38a.442.442 0 0 1 .482-.095Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSignInStyle0; }
}, [1, "cosmos-icon-sign-in", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sign-in"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sign-in":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSignIn$1);
            }
            break;
    } });
}

const CosmosIconSignIn = CosmosIconSignIn$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSignIn, defineCustomElement };
